module.exports = __webpack_public_path__ + "img/football 2.a25d1dfb.webp";